import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"
import { ResponseData } from "services/common"
import { UpdateLocationAddressType } from "services/rbo/location-details-api"

const defaultURL = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/rbo/onboarding-data`

// ============Get onboarding status data api============
export interface GetOnboardingStatusData {
  // id: number
  propertyId: string
  location: string | UpdateLocationAddressType | null // JSON string or parsed object
  locationStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
  pricing: string | PricingType | null
  pricingStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
  availability: string | AvailabilityType | null
  availabilityStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
  propertyDamage: string | PropertyDamageType | null
  propertyDamageStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
  cancellationPolicy: string | CancellationPolicy | null
  cancellationStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
  minAgeRequirement: string | null
  minAgeStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
  calendar: string | Calendar | null
  calendarStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
}

export interface GetOnboardingStatusDataResponseData extends ResponseData {
  data: GetOnboardingStatusData
}

export interface GetOnboardingStatusDataResponse extends AxiosResponse {
  data: GetOnboardingStatusDataResponseData
}

export interface GetOnboardingStatusDataRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    propertyId: string
  }
}

export function getOnboardingStatusData(
  {
    params,
    method = "get",
    url = `${defaultURL}?propertyId=${params.propertyId}`,
    ...config
  }: GetOnboardingStatusDataRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<GetOnboardingStatusDataResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<GetOnboardingStatusDataResponse>
}

// --------------- update onboarding status data api -----

export type PricingType = {
  minStayDays?: number | null
  maxStayDays?: number | null
  basePrice?: number | null
  discount?: number | null
  extendedDiscount?: number | null
  cleaningFee?: number
  petFee?: number
  petCount?: number
  petFeeType?: string
  tax?: number
  isTaxApplied?: boolean | null
  additionalGuestFee?: number | null
  additionalGuestCount?: number
  otherFeeValue?: number | null
  otherFeeType?: string
}

export type AvailabilityType = {
  minLengthStay?: number
  maxLengthStay?: number
}

export type PropertyDamageType = {
  isMyOwnPlan: boolean | string
  isWhimstayPlan: boolean | string
}

export type CancellationPolicy = {
  Partial: boolean
  Standard: boolean
  Moderate: boolean
  Strict: boolean
}

export type Calendar = {
  importCalendar: string
  exportCalendar: string
}

export type PropertyData = {
  propertyId: string
  location: string | UpdateLocationAddressType // JSON string or parsed object
  locationStatus: string
  pricing: string | PricingType
  pricingStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
  propertyDamage: string | PropertyDamageType
  propertyDamageStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
  cancellationPolicy: string | CancellationPolicy
  cancellationStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
  minAgeRequirement: string
  minAgeStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
  calendar: string | Calendar
  calendarStatus: "NOT_STARTED" | "INCOMPLETE" | "COMPLETE"
}

export interface UpdateOnboardingStatusDataRequest
  extends Partial<AxiosRequestConfig> {
  data: PropertyData | string
}

export function updateOnboardingStatusDataApi(
  {
    data,
    method = "post",
    url = `${defaultURL}`,
    ...config
  }: UpdateOnboardingStatusDataRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<GetOnboardingStatusDataResponse> {
  return axiosInstance({
    data,
    method,
    url,
    ...config,
  }) as Promise<GetOnboardingStatusDataResponse>
}
